export interface PurchaseLink { vendor: string; url?: string; price?: number | null; currency?: string }

export function purchaseUrl(value?: string): string | undefined {
  if (!value || value.includes('...')) return undefined;
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && url.hostname && !url.username && !url.password ? url.href : undefined;
  } catch { return undefined; }
}

export function purchasePrice(link: PurchaseLink): string | undefined {
  if (typeof link.price !== 'number' || !Number.isFinite(link.price) || link.price < 0) return undefined;
  const currency = /^[A-Za-z]{3}$/.test(link.currency ?? '') ? link.currency!.toUpperCase() : 'CNY';
  return new Intl.NumberFormat('zh-CN', { style: 'currency', currency, minimumFractionDigits: 2 }).format(link.price);
}

// Respect configured channel order. Comparing amounts in different currencies is misleading.
export function primaryPurchase(links: PurchaseLink[]): PurchaseLink | undefined {
  return links.find((link) => purchaseUrl(link.url));
}
